﻿const TAB_SELECTOR = "[data-viwo-tabs]";
const TAB_BUTTON_SELECTOR = "[data-viwo-tab-button]";
const TAB_PANEL_SELECTOR = "[data-viwo-tab-panel]";

export function initViwoTabs(root = document) {
    const tabGroups = Array.from(root.querySelectorAll(TAB_SELECTOR));

    tabGroups.forEach(group => {
        if (group.dataset.viwoTabsInitialized === "true") return;

        group.dataset.viwoTabsInitialized = "true";
        setupTabs(group);
    });
}

function setupTabs(group) {
    const buttons = Array.from(group.querySelectorAll(TAB_BUTTON_SELECTOR));
    const panels = Array.from(group.querySelectorAll(TAB_PANEL_SELECTOR));

    if (!buttons.length || !panels.length) return;

    const activeKey =
        group.dataset.viwoTabsActive ||
        buttons.find(x => x.classList.contains("active"))?.dataset.viwoTabButton ||
        buttons[0].dataset.viwoTabButton;

    activateTab(group, activeKey, false);

    buttons.forEach((button, index) => {
        button.addEventListener("click", () => {
            activateTab(group, button.dataset.viwoTabButton, true);
        });

        button.addEventListener("keydown", event => {
            handleTabKeyboard(event, group, buttons, index);
        });
    });
}

function activateTab(group, key, focusButton) {
    if (!key) return;

    const buttons = Array.from(group.querySelectorAll(TAB_BUTTON_SELECTOR));
    const panels = Array.from(group.querySelectorAll(TAB_PANEL_SELECTOR));

    buttons.forEach(button => {
        const isActive = button.dataset.viwoTabButton === key;

        button.classList.toggle("active", isActive);
        button.setAttribute("aria-selected", isActive ? "true" : "false");
        button.setAttribute("tabindex", isActive ? "0" : "-1");

        if (isActive && focusButton) {
            button.focus({ preventScroll: true });
        }
    });

    panels.forEach(panel => {
        const isActive = panel.dataset.viwoTabPanel === key;

        panel.hidden = !isActive;
        panel.classList.toggle("active", isActive);
    });

    group.dataset.viwoTabsActive = key;

    group.dispatchEvent(new CustomEvent("viwo:tab-changed", {
        bubbles: true,
        detail: {
            key
        }
    }));
}

function handleTabKeyboard(event, group, buttons, currentIndex) {
    let nextIndex = null;

    if (event.key === "ArrowRight" || event.key === "ArrowDown") {
        nextIndex = currentIndex + 1 >= buttons.length ? 0 : currentIndex + 1;
    }

    if (event.key === "ArrowLeft" || event.key === "ArrowUp") {
        nextIndex = currentIndex - 1 < 0 ? buttons.length - 1 : currentIndex - 1;
    }

    if (event.key === "Home") {
        nextIndex = 0;
    }

    if (event.key === "End") {
        nextIndex = buttons.length - 1;
    }

    if (nextIndex === null) return;

    event.preventDefault();

    const nextButton = buttons[nextIndex];
    activateTab(group, nextButton.dataset.viwoTabButton, true);
}

export function activateViwoTab(group, key) {
    if (!group || !key) return;

    activateTab(group, key, true);
}